import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MBTI } from 'src/app/interfaces/mbti';
import { weakColorCode } from 'src/utils/utils';

@Component({
  selector: 'app-survey-graph',
  templateUrl: './survey-graph.component.html',
  styleUrls: ['./survey-graph.component.scss'],
})
export class SurveyGraphComponent implements OnInit {

  constructor() { }

  @Input() mbti: MBTI | undefined;
  @Input() ratio: number | undefined;
  backgroundStyle = '';

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.mbti !== undefined && this.ratio !== undefined) {
      const weakColor = weakColorCode(this.mbti);
      const deg = 360 * (this.ratio / 100);
      this.backgroundStyle = `conic-gradient(${weakColor} 0deg ${deg}deg, #F7F8FA ${deg}deg 360deg)`;
    }
  }
}
